import { Services } from '@sigma-frontend-libs/commons'

import generatorRow from '@/components/generator/row'
import info from '@/components/info'
import item from '@/components/services/providers/senderNameToIds/item'

function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services.providers}.infos.senderNameToIds`)
      }
    }
  )
}

function renderItem(h, index) {
  return h(
    item,
    {
      props: {
        value: this.proxy[index],
        disabledNames: this.disabledNames
      },
      on: {
        input: event => {
          this.proxy[index] = event
        }
      }
    }
  )
}
function renderGenerator(h) {
  return h(
    generatorRow,
    {
      props: {
        value: this.proxy,
        defaultValue: {
          sendername: undefined,
          advertiserId: undefined,
          senderNumberId: undefined
        },
        gap: 8
      },
      scopedSlots: {
        row: ({ index }) => {
          return renderItem.call(this, h, index)
        }
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderInfo.call(this, h),
      renderGenerator.call(this, h)
    ]
  )
}
